import type {
	OriginalItemTypes,
	RenderableItemTypes,
} from "@memorang/types/src/session/new-session";

export const getTotalScoreForAiItem = (
	itemType: OriginalItemTypes | RenderableItemTypes,
) => {
	return itemType === "AUDIO_INPUT" ? 4 : 5;
};

export const getNormalizedScore = (score: number, totalScore: number) => {
	return (score / totalScore) * 100;
};
